// import auyFun from './modules/auyFun';
import auyFun from './modules/auyFun'
// import orderPay from "./modules/order"
import sell from "./modules/sell"

export default  {
    auyFun,
    sell,
}